import React, {Component} from 'react';
import EventListener from 'react-event-listener';

import ComputeStyle from './ComputeStyle';

const ScrollDirection = {
    vertical: 'vertical',
    horizontal: 'horizontal',
};

const InitialState = {
    scrollDirection: ScrollDirection.vertical,
};

class ScrollWatch extends Component {

    constructor(props) {
        super(props);

        this.onHorizontalScroll = this.onScroll.bind(this, ScrollDirection.horizontal);
        this.onVerticalScroll = this.onScroll.bind(this, ScrollDirection.vertical);
        this.state = InitialState;
    }

    render() {
        const {scrollDirection} = this.state;
        const {verticalElement, horizontalElement, render, children} = this.props;

        return (
            <EventListener target={verticalElement} onScroll={this.onVerticalScroll}>
                <EventListener target={horizontalElement} onScroll={this.onHorizontalScroll}>
                    {children ? cloneElement(children, {scrollDirection}) : render(scrollDirection)}
                </EventListener>
            </EventListener>
        );
    }

    onScroll(scrollDirection) {
        if (scrollDirection === this.state.scrollDirection) return;

        return this.setState({scrollDirection});
    }

}

ScrollWatch.defaultProps = {
    verticalElement: window,
    horizontalElement: window,
};

export {ScrollDirection, ComputeStyle};

export default ScrollWatch;
